import useSWR from 'swr';
import { useFetcher } from './use-fetcher';
import { IGeographicBoundaryResult } from '../../utils/types';

const GEOGRAPHIC_TYPE_ID = '&typeId.in=1,2,3,4,5,6,7,8,9,10,11,12,17';

export function useGeographicBoundary(props: {
  typeId?: number;
  parentId?: number;
}) {
  const fetcher = useFetcher();
  const queryParams = new URLSearchParams();
  if (props.typeId) {
    queryParams.set('typeId.equals', props.typeId.toString());
  }
  if (props.parentId) {
    queryParams.set('parentId.equals', props.parentId.toString());
  }
  const { data, error, isLoading } = useSWR<IGeographicBoundaryResult[]>(
    `/api/geographic-boundaries?${queryParams.toString()}${GEOGRAPHIC_TYPE_ID}&size=1000&sort=translations.name`,
    fetcher,
  );

  return {
    data,
    error,
    isLoading,
  };
}
